import { Logger } from './databaseInput';
import { Validator, ZodValidator } from './validator';
import { z } from 'zod';
import {
    DatabaseInputValidation,
    DBInputSoftValidation,
    DBInputValidation,
} from './databaseInput';

export const createDBInputValidation = <T extends Record<string, unknown>>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields?: string[];
    },
): DatabaseInputValidation<T> =>
    softValidation
        ? new DBInputSoftValidation<T>(
              validator,
              softValidation.logger,
              softValidation.hardErrorFields,
          )
        : new DBInputValidation<T>(validator);

export const createDBEntityValidator = <T extends Record<string, unknown>>(
    schema: z.ZodSchema<T>,
): Validator<T> => {
    return new ZodValidator<T>(schema);
};
